
interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-8 lg:px-16">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center gap-4">
            <img 
              src="https://public.readdy.ai/ai/img_res/30e657a4-6b3a-4f62-8ddb-2ba07cc873a1.png" 
              alt="MADRAS DOO SVILAJNAC Logo" 
              className="h-12 w-12 object-contain"
            />
            <span className={`text-xl font-bold transition-colors ${scrolled ? 'text-gray-900' : 'text-white'}`}>
              MADRAS DOO SVILAJNAC
            </span>
          </div>
          
          <div className="flex items-center gap-10">
            <button
              onClick={() => scrollToSection('home')}
              className={`text-base font-light transition-colors hover:opacity-70 whitespace-nowrap ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`text-base font-light transition-colors hover:opacity-70 whitespace-nowrap ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('products')}
              className={`text-base font-light transition-colors hover:opacity-70 whitespace-nowrap ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Products
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-base font-light transition-colors hover:opacity-70 whitespace-nowrap ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Contact
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
